module.exports = "<div id=\"chartContainerId\"></div>"